import { twMerge } from 'tailwind-merge';
import { Button } from '@/components/Button';
import { EqualizerIcon } from '@/components/SvgIcons/EqualizerIcon';
import { useTranslation } from 'react-i18next';

type ButtonAdvancedFilterProps = {
  id?: string;
  className?: string;
  text?: string;
  children: React.ReactNode;
  placement?: 'bottom-end' | 'bottom-start' | 'bottom-center';
};

const ButtonAdvancedFilter = ({
  id,
  className,
  text,
  children,
  placement = 'bottom-end',
}: ButtonAdvancedFilterProps) => {
  const { t } = useTranslation('common');
  const handleContainerClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  text = t('moreFilters');

  return (
    <div
      id={id}
      className={twMerge('dropdown', className)}
      data-dropdown="true"
      data-dropdown-placement={placement}
      data-dropdown-trigger="click"
    >
      <Button
        text={text}
        leftIcon={
          <EqualizerIcon className="w-3.5 h-3.5 [&>path]:fill-black-252E49 dark-mode:[&>path]:fill-gray-600" />
        }
        buttonClassName="btn bg-transparent dropdown-toggle px-0"
        textClassName="mt-0.5 text-black-252E49 dark-mode:text-gray-600"
      />
      <div
        className="dropdown-content menu-default w-auto p-5"
        onClick={handleContainerClick}
      >
        {children}
      </div>
    </div>
  );
};

export default ButtonAdvancedFilter;
